import { initMainSwiper } from './components/main-swiper';
import { initHeaderSearch } from './components/header-search';
import { initMobileMenu } from './components/mobile-menu';
import { initDesktopNav } from './components/desktop-nav';
import { initCallbackModal } from './components/callback-modal';
import { initOrderModal } from './components/order-modal';
import { initSpecialistModal } from './components/specialist-modal';
import { initSearchForms } from './components/search-form';
import { initSearchPagination } from './components/search-pagination';
import { initFooterAccordion } from './components/footer-accordion';

document.addEventListener('DOMContentLoaded', () => {
  initMainSwiper();
  initHeaderSearch();
  initMobileMenu();
  initDesktopNav();
  initCallbackModal();
  initOrderModal();
  initSpecialistModal();
  initSearchForms();
  initSearchPagination();
  initFooterAccordion();
});
